module.exports = __webpack_public_path__ + "img/organization-details.cb733155.svg";